import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePageTransition, SUNSARI_LOGO_URL } from '../PageTransition';

const Footer = () => {
  const { t } = useTranslation();
  const { navigateWithTransition } = usePageTransition();
  
  return (
    <footer className="bg-[#1A1A1A] py-16 md:py-20">
      <div className="max-w-[1800px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <img src={SUNSARI_LOGO_URL} alt="Sunsari" className="h-12 md:h-16 w-auto mb-4" />
            <p className="text-white/50 font-light leading-relaxed max-w-md text-sm">{t('footer.tagline')}</p>
          </div>
          <div>
            <p className="text-white text-xs tracking-[0.2em] uppercase mb-4">{t('footer.contact')}</p>
            <div className="space-y-2 text-white/50 font-light text-sm">
              <a href="https://www.google.com/maps/dir/?api=1&destination=Hietasaarenkatu+18+Vaasa" target="_blank" rel="noopener noreferrer" className="block hover:text-[#C97A2B] transition-colors" data-testid="footer-map-link">
                Hietasaarenkatu 18<br />
                65100 Vaasa, Finland
              </a>
              <a href="tel:0403779200" className="text-[#C97A2B] hover:text-[#C97A2B]/80 transition-colors block">040 377 9200</a>
              <p>ravintolasunsari@gmail.com</p>
            </div>
          </div>
          <div>
            <p className="text-white text-xs tracking-[0.2em] uppercase mb-4">{t('footer.hours')}</p>
            <div className="space-y-2 text-white/50 font-light text-sm">
              <p>{t('footer.monThu')}: 11:00 - 21:00</p>
              <p>{t('footer.friday')}: 11:00 - 22:00</p>
              <p>{t('footer.saturday')}: 12:00 - 22:00</p>
              <p className="text-[#C97A2B]">{t('footer.sunday')}: 12:00 - 20:00</p>
              <p className="pt-2 border-t border-white/10 mt-2 text-white/70">{t('footer.lunchHours')}</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-white/10">
          <p className="text-white/30 text-xs">© 2019 Sunsari Restaurant</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            {[{ name: t('nav.menu'), path: '/menu' }, { name: t('nav.about'), path: '/about' }, { name: t('nav.contact'), path: '/contact' }].map((item) => (
              <button key={item.path} onClick={() => navigateWithTransition(item.path)} className="text-white/50 text-xs tracking-[0.1em] uppercase hover:text-[#C97A2B] transition-colors" data-cursor-hover>{item.name}</button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
